export enum ReadingAssessmentPageChangeInteraction {
  SingleClick = "singleClick",
  DoubleClick = "doubleClick",
}

export interface ReliabilityAutoRestartRule {
  minErrorPercentage: number;
  minPresentations: number;
}

export type ReliabilityAutoRestartMetric = "falsePositive" | "falseNegative" | "fixationLoss";

export type VisualFieldAutoRestartConfiguration = Record<
  ReliabilityAutoRestartMetric,
  ReliabilityAutoRestartRule
> & {
  countdownSeconds: number;
};

export interface ReadingAssessmentAdminConfiguration {
  pageChangeInteraction: ReadingAssessmentPageChangeInteraction;
}

export interface OcularMotilityPatternConfiguration {
  patternSize: number;
  speed: number;
  pauseDuration: number;
}

/** The headset parameterises smooth pursuit as an orbit, not as a pattern. */
export interface SmoothPursuitOrbitConfiguration {
  depth: number;
  radiusDegrees: number;
  frequencyHz: number;
  clockwiseDuration: number;
  counterClockwiseDuration: number;
}

export interface OcularMotilityAdminConfiguration {
  xih: OcularMotilityPatternConfiguration;
  smoothPursuit: SmoothPursuitOrbitConfiguration;
}

export interface VisualFieldFixationLossConfiguration {
  movingFixationCatchTrials: boolean;
}

export interface AdminConfigurations {
  readingAssessment: ReadingAssessmentAdminConfiguration;
  visualFieldAutoRestart: VisualFieldAutoRestartConfiguration;
  ocularMotility: OcularMotilityAdminConfiguration;
  visualFieldFixationLoss: VisualFieldFixationLossConfiguration;
}

export interface AdminConfigurationsResponse extends AdminConfigurations {
  updatedAt?: string;
  updatedBy?: string;
}
